"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositiveNumberPipe = void 0;
/**
 * Positive Number Pipe
 *
 * The absolute value of that number
 */
class PositiveNumberPipe {
    /**
     * @param value a number
     * @returns The absolute value of that number
     */
    transform(value) {
        return Math.abs(value);
    }
}
exports.PositiveNumberPipe = PositiveNumberPipe;
//# sourceMappingURL=positiveNumber.pipe.js.map